import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Atoms/Icon';
import CUSTOM_EVENT from '../../../util/customEvents';

const propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  accordionType: PropTypes.string.isRequired,
  isEmpty: PropTypes.bool,
  onToggle: PropTypes.function,
};

const defaultProps = {
  isEmpty: false,
  onToggle: null,
};

const PackageComparisonAccordion = React.forwardRef(
  ({ title, children, accordionType, isEmpty = false, onToggle }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggleAccordion(accordionTypeToggled) {
      if (onToggle) {
        onToggle(!isOpen);
      }
      window.dispatchEvent(
        new CustomEvent(CUSTOM_EVENT.PACKAGE_COMPARE_ACCORDION_TOGGLED, {
          detail: accordionTypeToggled,
        })
      );
    }

    useEffect(() => {
      const handleAccordionToggle = (accordionToggleEvent) => {
        const openedAccordion = accordionToggleEvent.detail;
        if (openedAccordion === accordionType) {
          setIsOpen((prevState) => !prevState);
        }
      };

      window.addEventListener(
        CUSTOM_EVENT.PACKAGE_COMPARE_ACCORDION_TOGGLED,
        handleAccordionToggle
      );

      return () => {
        window.removeEventListener(
          CUSTOM_EVENT.PACKAGE_COMPARE_ACCORDION_TOGGLED,
          handleAccordionToggle
        );
      };
    }, []);

    if (isEmpty) {
      return (
        <div
          className={`PackageComparisonAccordion PackageComparisonAccordion__empty ${
            isOpen ? 'PackageComparisonAccordion--open' : ''
          }`}
          ref={ref}
        >
          <div className="PackageComparisonAccordion__emptyTitle">
            <span className="PackageComparisonAccordion__titleText">{title}</span>
          </div>
          {isOpen && <div className="PackageComparisonAccordion__content">{children}</div>}
        </div>
      );
    }

    return (
      <div
        className={`PackageComparisonAccordion ${isOpen ? 'PackageComparisonAccordion--open' : ''}`}
        ref={ref}
      >
        <button
          type="button"
          className="PackageComparisonAccordion__title"
          onClick={() => toggleAccordion(accordionType)}
          aria-expanded={isOpen}
        >
          <span className="PackageComparisonAccordion__titleText">{title}</span>
          <span className="PackageComparisonAccordion__icon">
            {isOpen ? (
              <Icon id="arrow-up" blockName="PackageComparisonAccordion__upArrow" />
            ) : (
              <Icon id="arrow-down" blockName="PackageComparisonAccordion__downArrow" />
            )}
          </span>
        </button>
        {isOpen && <div className="PackageComparisonAccordion__content">{children}</div>}
      </div>
    );
  }
);

PackageComparisonAccordion.propTypes = propTypes;
PackageComparisonAccordion.defaultProps = defaultProps;

export default PackageComparisonAccordion;
